// store instancia

// autenticacion
import {
    passport
} from "@/store/auth/passport";
import {
    role
} from "@/store/auth/role";
import {
    user
} from "@/store/auth/user";

// logica de negocio
import {
    dashboard
} from "@/store/modules/Dashboard/Dashboard";
import {
    tail
} from "@/store/modules/report/tail";
import {
    clients
} from "@/store/modules/Clients/Clients";
import {
    layout
} from "@/store/modules/Layout/layout";
import {
    breaks
} from "@/store/modules/Breaks/Breaks";
import {
    assistance
} from "@/store/modules/Assistance/Assistance";
import {
    queue
} from "@/store/modules/Typifications/Queue";
import {
    typifications
} from "@/store/modules/Typifications/Typifications";
import {
    callsInfo
} from "@/store/modules/CallsInfo";
import {
    extension
} from "@/store/modules/Typifications/Extension";
import categories from "@/store/modules/Categories";
import questions from "@/store/modules/Questions";
import answers from "@/store/modules/Answers";
import evaluations from "@/store/modules/Evaluations";
import evaluationProcess from "@/store/modules/EvaluationProcess";
import tests from "@/store/modules/Tests";
import callReports from '@/store/modules/CallReports';
import dialer from '@/store/modules/Dialer';
import chats from '@/store/modules/Chats';
import agents from '@/store/modules/Agents';

import Vue from "vue";
import Vuex from "vuex";
// import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
    modules: {
        dashboard,
        callsInfo,
        passport,
        role,
        user,
        tail,
        clients,
        layout,
        breaks,
        assistance,
        queue,
        typifications,
        extension,
        categories,
        questions,
        answers,
        evaluations,
        tests,
        callReports,
        dialer,
        chats,
        agents,
        process: evaluationProcess
    },
    // plantilla
    state: {
        // estatico
        // layout: {
        // 	navPos: null,
        // 	toolbar: null,
        // 	footer: null,
        // 	boxed: false,
        // 	roundedCorners: false,
        // 	viewAnimation: 'fade-top'
        // },
        // loading app
        drawer: null,
        splashScreen: false,
        logged: false,
        refreshChats: false,
    },
    mutations: {
        SETDRAWER(state) {
            state.drawer = true;
        },
        setLogin(state, payload) {
            state.logged = true;
        },
        setLogout(state, payload) {
            state.logged = false;
        },
        setSplashScreen(state, payload) {
            state.splashScreen = payload;
        },
        TRIGGER_REFRESH_CHATS(state) {
            state.refreshChats = !state.refreshChats; // Cambiar el estado para desencadenar la acción
        },
    },

    actions: {
        triggerRefreshChats({ commit }) {
            commit("TRIGGER_REFRESH_CHATS");
        },
    },

    getters: {
        isLogged(state, getters) {
            return state.logged;
        },
        splashScreen(state, getters) {
            return state.splashScreen;
        }
    },
    // plugins: [createPersistedState({ paths: ['layout'] })],
    strict: debug
});
